export class HttpParameters {
  /**
   * TODO-FE[later] review usage of any
   */
  public data: { [key: string]: any } | undefined;

  /**
   *
   * @param data // TODO-FE[later] review usage of any
   */
  constructor(data?: { [key: string]: any } | undefined) {
    this.data = data;
  }

  /**
   * Converts data object into a string of URL parameters
   */
  public toQueryString(): string {
    let params = '';

    if (this.data instanceof Object) {
      params = Object.keys(this.data)
        .sort()
        .map((key: string) => {
          // Array value
          if (Array.isArray(this.data[key])) {
            return this.data[key]
              .map((value: string) => {
                return encodeURIComponent(key) + '[]=' + encodeURIComponent(value);
              })
              .join('&');

            // Object value
          } else if (this.data[key] instanceof Object) {
            const paramObj = this.data[key];

            return Object.keys(paramObj)
              .map((subKey) => {
                return (
                  `${encodeURIComponent(key)}[${encodeURIComponent(subKey)}]` +
                  `=${encodeURIComponent(paramObj[subKey])}`
                );
              })
              .join('&');
            // Single value
          } else {
            return encodeURIComponent(key) + '=' + encodeURIComponent(this.data[key]);
          }
        })
        .filter((value: string) => !!value)
        .join('&');
    }

    return params;
  }

  /**
   * Converts data object into json string for request payload
   */
  public toPayloadString(): string {
    if (this.data instanceof Object) {
      return JSON.stringify(this.data);
    } else {
      return '';
    }
  }
}
